module.exports = {"511132100":"沙坪镇","511132101":"大堡镇","511132102":"毛坪镇","511132103":"五渡镇","511132104":"新林镇","511132105":"黑竹沟镇","511132200":"红花乡","511132201":"宜坪乡","511132202":"杨村乡","511132203":"白杨乡","511132204":"觉莫乡","511132205":"万坪乡","511132206":"杨河乡","511132207":"共和乡","511132208":"新场乡","511132209":"平等乡","511132210":"哈曲乡","511132211":"金岩乡","511132212":"勒乌乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511132.json
// module id = 2337
// module chunks = 0